import { useParams } from "react-router-dom";
import newsItems from "./newsItems";
import Navbar from "./Navbar";
import Footer from "./Footer";

const SingleNews = () => {
  const { id } = useParams();
  const news = newsItems.find((item) => item.id === parseInt(id));

  if (!news) return <div className="container my-5">News not found.</div>;

  return (
    <>
      <Navbar />
      <div className="container my-5">
        <h2 className="mb-3 fw-bold text-secondary">{news.title}</h2>
        <p className="text-muted">{news.date}</p>
        <img
          src={news.image}
          alt={news.title}
          className="img-fluid mb-4"
          style={{
            maxHeight: "400px",
            objectFit: "cover",
            width: "100%",
            objectPosition: "top",
          }}
        />
        {news.content.map((paragraph, index) => (
          <p key={index} className="lead">
            {paragraph}
          </p>
        ))}
      </div>
      <Footer />
    </>
  );
};

export default SingleNews;
